var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1847_23217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55867 23.9999C3.55867 23.8992 3.53997 23.8062 3.53997 23.6978C3.53997 20.262 3.53997 16.8256 3.53997 13.3885V13.067H0V8.78298H3.5381C3.5381 8.66096 3.5381 8.56994 3.5381 8.47698C3.5381 7.35174 3.51567 6.22649 3.56803 5.10319C3.63722 3.58479 4.11781 2.23295 5.27162 1.21617C6.04104 0.551227 6.99004 0.148749 7.98878 0.063807C9.1856 -0.0659541 10.3824 0.0289449 11.5755 0.135465L11.9981 0.168392V3.98956H11.7662C10.9827 4.00312 10.1973 3.99925 9.41562 4.03411C8.41141 4.07672 7.86162 4.61513 7.81861 5.65322C7.7756 6.69131 7.81861 7.71197 7.81861 8.78105H11.8822C11.6952 10.22 11.5269 11.6319 11.3492 13.0651H7.82048C7.82048 13.1484 7.80552 13.2104 7.80552 13.2704V23.8837C7.80552 23.9224 7.80552 23.9612 7.80552 23.9999H3.55867Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1847_23217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7aa604e5f7886adc2c39ffa2b0bbb963.svg";
export { ForwardRef as ReactComponent };